<template>
  <FreeModal :name="name" persistent>
    <template #default="{ hide }">
      <div class="space-y-4">
        <p
          class="text-text-neutral-primary text-center text-sm whitespace-pre-line"
        >
          {{ $t('passengersData.specialSymbolsWarning.description') }}
        </p>
        <p class="text-text-neutral-tertiary text-center text-sm">
          {{ $t('passengersData.specialSymbolsWarning.example') }}
        </p>
        <FreeButton class="gray-button w-full" type="button" @click="hide">
          {{ $t('passengersData.specialSymbolsWarning.ok') }}
        </FreeButton>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { FreeModal, FreeButton } from 'freedom-shared';

  defineProps<{
    name: string;
  }>();
</script>
